import { useEffect } from "react";
import { HubConnectionState } from "@microsoft/signalr";
import { useSnackbar } from "notistack";
import { useSignalR } from "../../hooks/useSignalR";

const AUTO_HIDE_DURATION = 2000; // Shorter than default

function SignalRConnectionStatusNotification() {
    const { signalRProviderConnectionState } = useSignalR();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const getSnackbarKey = (state: HubConnectionState) => {
        return `SignalRConnectionState_${state}`;
    };

    useEffect(() => {
        console.log("SignalRConnectionState:", signalRProviderConnectionState);

        // Dismiss all existing snackbars for connection states, so only one is shown at a time
        for (const state in HubConnectionState) {
            closeSnackbar(
                getSnackbarKey(
                    HubConnectionState[state as keyof typeof HubConnectionState]
                )
            );
        }

        switch (signalRProviderConnectionState) {
            // `Connecting` and `Disconnecting` states are transient and not useful to show
            case HubConnectionState.Connected:
                enqueueSnackbar("Connected successfully", {
                    variant: "success",
                    key: getSnackbarKey(signalRProviderConnectionState),
                    autoHideDuration: AUTO_HIDE_DURATION // Only show briefly
                });
                return;

            case HubConnectionState.Disconnected:
                enqueueSnackbar(
                    "You're disconnected. Please reconnect to internet, then refresh your browser.",
                    {
                        variant: "error",
                        key: getSnackbarKey(signalRProviderConnectionState),
                        persist: true // Stay until state changes
                    }
                );
                return;

            case HubConnectionState.Reconnecting:
                // This will be the most common state when experiencing connection issues
                enqueueSnackbar(
                    "Poor connection detected. Please check your internet. Attempting to reconnect...",
                    {
                        variant: "warning",
                        key: getSnackbarKey(signalRProviderConnectionState),
                        persist: true // Stay until state changes
                    }
                );
                return;
        }
    }, [closeSnackbar, signalRProviderConnectionState, enqueueSnackbar]);

    return <></>;
}

export default SignalRConnectionStatusNotification;
